<template>
  <!-- 하루만 선택 가능한 캘린더 -->
  <date-range-picker
      ref="refDate"
      :locale-data="{format: 'YYYY-MM-DD'}" 
      :singleDatePicker="bSelect"
      :timePicker="false"
      :showWeekNumbers="bSelect"
      :showSidePicker="bSelect"
      :autoApply="true"
      :minDate="sMinDate"
      :maxDate="sMaxDate"
      v-model="dateRange"
      @update="onDateRangeChange"
    >
      <div slot="input">
        <!-- @click="ShwoDialog()" -->
        <v-combobox
          v-model="value"
          class="mb-10"
          v-on:change="onDateChange()"
          dense
          readonly
          hide-details
        >
          <template v-slot:label>
            <div v-if="cLabel != ''">{{cLabel}}</div>
            <div v-if="cLabelEs != ''">{{cLabelEs}}<strong class="red--text">*</strong></div>
          </template>
        </v-combobox>
      </div>
  </date-range-picker>
</template>
<script>
import Util from "../../../Util.js";
import DateRangePicker from './DateRangePicker3.vue'

var sNowSelectDate = "";

export default {
  components: {
    DateRangePicker,
  },
  model: {
    event: 'update',
  },
  props: ['value','cLabel','cLabelEs','bSelect','sMinDate',"sMaxDate"],
  created() {
    // this.sNowSelectDate = this.value;
    this.sStartDate = this.sNowSelectDate.substring(0,10);
    this.sEndDate = this.sNowSelectDate.substring(13,23);
  },
  data() {
    return {
      sDateError : "",
      sCheck3Month : "",
      sNowSelectDate,
      dateRange : {
        startDate:"",
        endDate:"",
      },
      // sMinDate : new Date(),
    }
  },
  methods: {
    // SetDate(sDate){
    //   this.sNowSelectDate = sDate;
    // },
    onDateRangeChange(daterange){
      let date = new Date(daterange.startDate)
      
      this.sCheck3Month = new Date(date.setMonth(daterange.startDate.getMonth() + 3))
      if (this.sCheck3Month <= daterange.endDate) {
        this.$emit('overmaxperiod',{sTitle : "기간을 다시 선택 하여 주세요.", sMsg : "최대 3개월까지만 선택 가능합니다."})
      } else {
        this.sStartDate = Util.sFormatDate(daterange.startDate);
        this.sEndDate = Util.sFormatDate(daterange.endDate);
        this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
        this.$emit('update', {startDate: this.sStartDate, endDate: this.sEndDate})
      }
    },


    onDateChange(){
      // this.$refs.refDate.togglePicker(false, null);
      //this.$refs.refDate.clickAway();

      var bOkDate = false;
      if (this.sNowSelectDate.length == 23) {
        if (Util.checkDate(this.sNowSelectDate.substring(0,10))) {
          if (Util.checkDate(this.sNowSelectDate.substring(13,23))) {
            if (this.sNowSelectDate.substring(0,10) <= this.sNowSelectDate.substring(13,23)) {
              bOkDate = true;
            }
          }
        }
      }
      if (bOkDate) {
        this.sStartDate = this.sNowSelectDate.substring(0,10);
        this.sEndDate = this.sNowSelectDate.substring(13,23);
        this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate; 
        this.$emit('update', {startDate: this.sStartDate, endDate: this.sEndDate})
      } else {
        this.sDateError = "Invalid date.(YYYY-MM-DD)";
        setTimeout(() => {
          this.sDateError = ""
          this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
        }, 1000);
      }        
    },   
  }
};

</script>
